import L from 'leaflet';
import Utils from '../_Utils';

export default class TextMarker extends L.Marker
{
	constructor(latlng, texts, lang = 'ja', fontSizeID = 1, rotation = 0, options = {})
	{
		super(latlng, options);

		this._texts = texts;
		this._rotation = rotation;
		this._lang = lang;
		this._fontSizeID = fontSizeID;
		this._minZoomLevel = options.minZoomLevel;

		// Set the initial icon
		this.setIcon(this.createIcon(texts[lang]));
	}

	createIcon(text)
	{
		const iconHtml = this.makeHTML(text);
		return L.divIcon({
			className: 'text-marker',
			html: iconHtml,
			iconSize: [300, 60],
			...(this._minZoomLevel !== undefined && { 'data-min-zoom': this._minZoomLevel })
		});
	}

	makeHTML(text)
	{
		return `<div class="marker-text" style="transform: rotate(${this._rotation}deg);" data-font-size="${this._fontSizeID}" data-min-zoom="${this._minZoomLevel}">
            ${Utils.toBRP(text)}
        </div>`;
	}

	updateText()
	{
		const newText = this._texts[this._lang];

		// Access and update the icon's HTML directly
		const iconElement = this.getElement();
		if (iconElement)
		{
			iconElement.querySelector('.marker-text').innerHTML = Utils.toBRP(newText);
		}
	}

	// Getter and setter for lang
	get lang()
	{
		return this._lang;
	}

	set lang(newLang)
	{
		if (this._texts[newLang])
		{
			this._lang = newLang;
			this.updateText();
		}
	}
}
